import { values } from '@fortem-monorepo/js-utilities';
export const ISSUER = {
    MorganStanleyBv: 'Morgan Stanley B.V.',
    SgIssuer: 'SG Issuer',
    CitigroupLuxembourg: 'Citigroup Global Markets Funding Luxembourg S.C.A',
    CanadianImperialBankOfCommerce: 'Canadian Imperial Bank of Commerce',
    SantanderUk: 'Santander UK',
    SgIssuerG7Collateral: 'SG Issuer - G7 Collateral',
    GoldmanSachsWertpapier: 'Goldman Sachs & Co. Wertpapier GmbH',
    JpMorgan: 'JP Morgan',
    GoldmanSachsFinanceCorpInternational: 'Goldman Sachs Finance Corp International Ltd., Jersey',
    GoldmanSachsInternational: 'Goldman Sachs International',
    BarclaysBank: 'Barclays Bank PLC',
    MorganStanleyInternational: 'Morgan Stanley & Co International (MSIP)',
    BnpParibas: 'BNP Paribas',
    Nomura: 'Nomura',
};
export const ISSUERS = values(ISSUER);
